import React from 'react';
import {
  HierarchicalMenuPanel,
  mappers,
  SearchBox,
  WhiteInstantSearchBuilder,
} from '@white-nl/instantsearch-components';

import { MagnifyingGlassSharpRegular, XmarkSharpRegular } from '../components/ui/icons';

const settings = document.getElementById('section-filters')?.dataset || {};
const whiteInstantSearch = new WhiteInstantSearchBuilder();
if (settings) {
  const graphqlUrl = `${settings.nodeUrl}api/categories/products`;
  fetch(graphqlUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ siteId: settings.siteId }),
  }).then((res) => res.json())
    .then((categories) => {
      const categoryLabelMapping: any = {};
      const categoryDisplaySequenceMapping: any = {};
      const categoryHasChildrenMapping: any = {};
      categories.overview.forEach(
        (category: {
          __typename: string;
          uri: string;
          title: string;
        }) => {
          categoryLabelMapping[category.uri] = category.title;
          categoryDisplaySequenceMapping[category.uri] = 0;
        },
      );
      categories.entries.forEach(
        (category: {
          __typename: string;
          slug: string;
          title: string;
          displaySequence: number;
          parent: {
            slug: string;
          };
        }) => {
          categoryLabelMapping[category.slug] = category.title;
          categoryDisplaySequenceMapping[category.slug] = category.displaySequence ?? 999999;
          if (category.parent) {
            categoryHasChildrenMapping[category.parent.slug] = 1;
          }
        },
      );

      const transformMenuItems = (items: any) => items.map((item: any) => {
        if (item.data && item.data.length > 0) {
          return Object.assign(item, { data: transformMenuItems(item.data) });
        }

        return Object.assign(item, { data: null });
      });
      whiteInstantSearch
        .withSearchkit(
          settings.indexName || '',
          settings.publicUrl || '',
          settings.jwt || '',
          settings.refreshUrl || '',
        )
        .withWhiteInstantSearchRouting({
          baseUrl: settings.baseUrl,
          pathAttribute: 'categories.lvl1',
          addToPath: true,
          addTrailingSlashesToUrls: settings.trailingSlashes === '1',
          writeDelay: 0,
        })
        .addHierarchicalMenu(
          [
            {
              settings: {
                attributes: [
                  'categories.lvl1',
                  'categories.lvl2',
                  'categories.lvl3',
                  'categories.lvl4',
                  'categories.lvl5',
                ],
                classNames: {
                  root: 'filters-list',
                  count: 'filters-count',
                  selectedItem: 'active',
                },
                sortBy: (a, b) => {
                  const titleA = categoryDisplaySequenceMapping[a.name];
                  const titleB = categoryDisplaySequenceMapping[b.name];
                  if (titleA > titleB) {
                    return 1;
                  }
                  if (titleA < titleB) {
                    return -1;
                  }

                  return 0;
                },
                separator: '/',
                hardRefresh: true,
                transformItems: (items) => {
                  const transformed = transformMenuItems(items);
                  return mappers.transformers.mapLabels(categoryLabelMapping)(transformed);
                },
                panelSettings: {
                  collapsiblePanelSettings: {
                    classNames: {
                      root: 'form-wrap form-wrap--with-margin collapsible-panel--category-menu',
                      header: 'filter-title h4',
                    },
                    defaultExpanded: true,
                    canCollapse: true,
                  },
                  header: Craft.t('catalog', 'Products'),
                },
              },
              component: HierarchicalMenuPanel,
            },
          ],
          '#white-instant-search-hierarchical-menu',
        )
        .addHierarchicalMenu(
          [
            {
              settings: {
                attributes: [
                  'categories.lvl1',
                  'categories.lvl2',
                  'categories.lvl3',
                  'categories.lvl4',
                  'categories.lvl5',
                ],
                sortBy: (a, b) => {
                  const titleA = categoryDisplaySequenceMapping[a.name];
                  const titleB = categoryDisplaySequenceMapping[b.name];
                  if (titleA > titleB) {
                    return 1;
                  }
                  if (titleA < titleB) {
                    return -1;
                  }

                  return 0;
                },
                separator: '/',
                hardRefresh: true,
                transformItems: (items) => {
                  const transformed = transformMenuItems(items);
                  return mappers.transformers.mapLabels(categoryLabelMapping)(transformed);
                },
              },
              component: ({ menu }) => {
                document.querySelectorAll('.card-category--hits').forEach((element: any) => {
                  element.style.setProperty('display', 'none');
                });
                menu.items.forEach((item, index) => {
                  document.querySelectorAll(`.card-category--${item.value}`).forEach((element: any) => {
                    element.style.setProperty('display', 'block');
                    element.style.setProperty('order', index);
                  });
                });
                return null;
              },
            },
          ],
          '#white-instant-search-hits',
        )
        .addSearchingComponent([
          {
            settings: {
              classNames: {
                submit: 'submit',
                reset: 'submit',
                loadingIndicator: 'submit',
                input: 'form-control',
              },
              submitIconComponent: () => (
                <MagnifyingGlassSharpRegular />
              ),
              resetIconComponent: () => (
                <XmarkSharpRegular />
              ),
              placeholder: Craft.t('catalog', 'Find your product'),
              translations: {
                submitButtonTitle: Craft.t('catalog', 'Submit the search query'),
                resetButtonTitle: Craft.t('catalog', 'Clear the search query'),
              },
            },
            component: SearchBox,
          },
        ])
        .where(`siteId:${settings.siteId} AND isAvailableInSiteRegion:true`)
        .build()
        .show();
    });
}
